import React from 'react';
import { MuiStack } from '../../../../components';
import { IconButton, Typography } from '@mui/material';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
var RelatedDocumentsCatalogReceivedEdit = function () {
    var columns = [{
            field: 'FFR number.',
            headerName: 'FFR number',
            headerAlign: 'center',
            minWidth: 100
        }, {
            type: 'string',
            field: 'RM name',
            headerName: 'RM name',
            minWidth: 150,
            flex: 1
        }, {
            field: 'ASM name',
            headerName: 'ASM namer',
            minWidth: 170,
            flex: 1
        }, {
            field: 'ASM contact no.',
            headerName: 'ASM contact no.',
            minWidth: 180
        }, {
            field: 'State',
            headerName: 'State & city',
            minWidth: 150,
            renderCell: function (params) {
                var _params$row$State, _params$row, _params$row$City, _params$row2;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$State = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.State) !== null && _params$row$State !== void 0 ? _params$row$State : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$City = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.City) !== null && _params$row$City !== void 0 ? _params$row$City : "")));
            }
        }, {
            field: 'Dealer name & code',
            headerName: 'Dealer name & code',
            minWidth: 180,
            renderCell: function (params) {
                var _params$row$Dealernam, _params$row3, _params$row$Dealercod, _params$row4;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$Dealernam = params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.Dealername) !== null && _params$row$Dealernam !== void 0 ? _params$row$Dealernam : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$Dealercod = params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.Dealercode) !== null && _params$row$Dealercod !== void 0 ? _params$row$Dealercod : "")));
            }
        }, {
            field: 'Branch',
            headerName: 'Branch',
            minWidth: 150
        }, {
            field: 'Model name & codew',
            headerName: 'Model name & codew',
            minWidth: 180,
            renderCell: function (params) {
                var _params$row$modelName, _params$row5, _params$row$modelCode, _params$row6;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$modelName = params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.modelName) !== null && _params$row$modelName !== void 0 ? _params$row$modelName : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$modelCode = params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.modelCode) !== null && _params$row$modelCode !== void 0 ? _params$row$modelCode : "")));
            }
        }, {
            field: 'Chassis number',
            headerName: 'Chassis number',
            minWidth: 180
        },
        // {
        //     field: 'Engine number',
        //     headerName: 'Engine number',
        //     minWidth: 180
        // },
        // {
        //     field: 'Prod. month',
        //     headerName: 'Prod. month',
        //     minWidth: 130
        // },
        // {
        //     field: 'Part name & code',
        //     headerName: 'Part name & code',
        //     minWidth: 180,
        //     renderCell(params) {
        //         return (
        //             <MuiStack direction={'column'}>
        //                 <Typography variant="caption">
        //                     {params?.row?.partName ?? ""}
        //                 </Typography>
        //                 <MuiStack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        //                     <Typography variant="caption" color={'secondary'}>
        //                         {params?.row?.partCode ?? ""}
        //                     </Typography>
        //                 </MuiStack>
        //             </MuiStack>
        //         )
        //     },
        // },
        // {
        //     field: 'Defect description & code',
        //     headerName: 'Defect description & code',
        //     minWidth: 180,
        //     renderCell(params) {
        //         return (
        //             <MuiStack direction={'column'}>
        //                 <Typography variant="caption">
        //                     {params?.row?.defectDescription ?? ""}
        //                 </Typography>
        //                 <MuiStack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        //                     <Typography variant="caption" color={'secondary'}>
        //                         {params?.row?.defectCode ?? ""}
        //                     </Typography>
        //                 </MuiStack>
        //             </MuiStack>
        //         )
        //     },
        // },
        // {
        //     field: 'KM reading',
        //     headerName: 'KM reading',
        //     minWidth: 150
        // },
        // {
        //     field: 'Repair type',
        //     headerName: 'Repair type',
        //     minWidth: 150
        // },
        // {
        //     field: 'Sale date',
        //     headerName: 'Sale date',
        //     minWidth: 150
        // },
        // {
        //     field: 'JC open date',
        //     headerName: 'JC open date',
        //     minWidth: 180
        // },
        {
            field: 'Action',
            headerName: 'Action',
            minWidth: 120,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(IconButton, {
                    children: /*#__PURE__*/ React.createElement(RemoveRedEyeOutlined, null)
                });
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        rows: [{
                id: 1,
                'FFR number.': 'FFR123456',
                'RM name': 'BM Rushikesh',
                'ASM name': 'Prashant Sharma',
                'ASM contact no.': '9876543210',
                'State': 'Maharashtra',
                'City': 'Pune',
                'Dealername': 'Chennai Auto',
                'Dealercode': 'DM002',
                'Branch': 'Pimpri',
                modelName: 'Pulsar 150',
                modelCode: 'MDL001',
                'Chassis number': 'MD2A11CX5PCH12345',
                'Engine number': 'DHXCPH98765',
                'Prod. month': 'Jan 2025',
                partName: 'Brake Pad',
                partCode: 'PRD456',
                defectDescription: 'Worn Out',
                defectCode: 'DFC123',
                'KM reading': '15000',
                'Repair type': 'Warranty',
                'Sale date': '2024-12-15',
                'JC open date': '2025-01-10',
                'Action': 'View'
            }, {
                id: 2,
                'FFR number.': 'FFR654321',
                'RM name': 'BM Rushikesh',
                'ASM name': 'Prashant Mehta',
                'ASM contact no.': '9123456780',
                'State': 'Tamil Nadu',
                'City': 'Chennai',
                'Dealername': 'Chennai Auto',
                'Dealercode': 'DM002',
                'Branch': 'Anna Nagar',
                modelName: 'Avenger 220',
                modelCode: 'MDL002',
                'Chassis number': 'MD2A11CX5PCH67890',
                'Engine number': 'DHXCPH54321',
                'Prod. month': 'Feb 2025',
                partName: 'Clutch Plate',
                partCode: 'PRD789',
                defectDescription: 'Slippage',
                defectCode: 'DFC456',
                'KM reading': '12000',
                'Repair type': 'Paid',
                'Sale date': '2025-01-20',
                'JC open date': '2025-02-05',
                'Action': 'View'
            }],
        dataGridProps: {
            sx: {
                borderRadius: 0,
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none'
            },
            initialState: {
                pinnedColumns: {
                    right: ['Action']
                }
            }
        }
    }));
};
export default RelatedDocumentsCatalogReceivedEdit;
